import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReactNode } from 'react';
import { RootState } from '../../app/store';

interface IDrawerState {
  title?: string;
  content?: ReactNode;
  open?: boolean;
  width?: number | string;
}

const initialState: IDrawerState = {
  title: '',
  content: null,
  open: false,
  width: 400,
};

const drawerSlice = createSlice({
  name: 'drawer_slice',
  initialState,
  reducers: {
    setDrawer(state, action: PayloadAction<Partial<IDrawerState>>) {
      return { ...state, ...action.payload };
    },
    openDrawer(state, action: PayloadAction<Partial<IDrawerState>>) {
      return { ...state, ...action.payload, open: true };
    },
    closeDrawer(state) {
      state.open = false;
    },
  },
});

export const { setDrawer, openDrawer, closeDrawer } = drawerSlice.actions;

export const selectDrawer = (state: RootState) => state.drawerSlice;

export default drawerSlice.reducer;
